// Scroll Reveal
function initReveal() {
  const isEditor = (window.Shopify && window.Shopify.designMode) || document.body.classList.contains('shopify-design-mode');
  const reveals = document.querySelectorAll(".reveal");
  if (isEditor) {
    reveals.forEach((el) => el.classList.add("visible"));
    return;
  }
  const ro = new IntersectionObserver(
    (es, observer) =>
      es.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
          observer.unobserve(e.target);
        }
      }),
    { threshold: 0.05, rootMargin: "60px" },
  );
  reveals.forEach((el) => {
    if (!el.classList.contains("visible")) {
      ro.observe(el);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initReveal);
} else {
  initReveal();
}

// Re-run for Shopify Theme Editor events
document.addEventListener("shopify:section:load", initReveal);
document.addEventListener("shopify:section:select", initReveal);
document.addEventListener("shopify:section:deselect", initReveal);
document.addEventListener("shopify:block:select", initReveal);
document.addEventListener("shopify:block:deselect", initReveal);

// FAQ Accordion
function toggleFaq(btn) {
  const item = btn.closest(".faq-item");
  const isOpen = item.classList.contains("open");
  document.querySelectorAll(".faq-item").forEach((i) => {
    i.classList.remove("open");
    i.querySelector(".faq-q").setAttribute("aria-expanded", "false");
  });
  if (!isOpen) {
    item.classList.add("open");
    btn.setAttribute("aria-expanded", "true");
  }
}
document.querySelectorAll(".faq-q").forEach((q) =>
  q.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFaq(q);
    }
  }),
);

// Sub-pill active
document.querySelectorAll(".sub-pill").forEach((p) =>
  p.addEventListener("click", () => {
    document
      .querySelectorAll(".sub-pill")
      .forEach((x) => x.classList.remove("active"));
    p.classList.add("active");
  }),
);

// Newsletter
const nlForm = document.querySelector(".nl-form");
if (nlForm) {
    nlForm.addEventListener("submit", function(e) {
        // e.preventDefault();
        const btn = document.getElementById("nl-submit-btn");
        const inp = document.getElementById("nl-email");
        if (btn && inp) {
            const oldText = btn.textContent;
            btn.textContent = "✓ You're In!";
            btn.style.background = "var(--navy)";
            inp.value = "";
            inp.placeholder = "Welcome to the ATOZ family! 🎉";
            setTimeout(() => {
                btn.textContent = oldText;
                btn.style.background = "";
                inp.placeholder = "Enter your email address";
            }, 4000);
        }
    });
}

// Sticky header shadow
window.addEventListener("scroll", () => {
  const header = document.getElementById("site-header");
  if (header) {
      header.style.boxShadow =
        window.scrollY > 10
          ? "0 4px 24px rgba(26,43,94,0.15)"
          : "0 2px 8px rgba(26,43,94,0.08)";
  }
});

// Add to cart animation
document.querySelectorAll(".add-btn").forEach((btn) =>
  btn.addEventListener("click", function (e) {
    e.stopPropagation();
    this.textContent = "✓";
    this.style.background = "var(--mint)";
    this.style.color = "var(--navy)";
    setTimeout(() => {
      this.textContent = "+";
      this.style.background = "";
      this.style.color = "";
    }, 1200);
  }),
);